import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { TempTravail } from '../models/options/tempTravails/tempTravail'

const resource = 'TempsTravail'

export default class TempsTravailResource {
  public async paginatedList(pagenumber?: number, pagesize?: number, actifonly?: boolean) : Promise<PaginatedList<TempTravail>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString());
    if (actifonly) params.append('ActifOnly', actifonly.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
